import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { QuoterStateService } from '../quoter/services/quoter-state.service';

export const terminalFlowGuard: CanActivateFn = () => {
  inject(QuoterStateService).markTerminal();
  return true;
};
